import { withInstall } from '../../../../utils/with-install'
import TileLayer from './TileLayer.vue'

export const ElAmapLayerTile = withInstall(TileLayer)
export default ElAmapLayerTile
